import { intFromUnknown, strFromUnknown } from '@/lib/primitive-utils';
import { LabeledSelectRow, LabeledTextRow } from './shared/field-primitives';
import { WidthField } from './shared/tolerance-width-fields';
import type { BuilderPropertyRecord, ShortAnswerToolSettingsProps } from './tool-defaults';

export function selectFunctionsToolProps(p: BuilderPropertyRecord) {
    return {
        functions_variables: strFromUnknown(p.functions_variables, 'a,b,c,d,e,f'),
        width: intFromUnknown(p.width, 150),
    };
}

function FunctionsToolSettingsInner(
    props: ReturnType<typeof selectFunctionsToolProps> & {
        onPatch: (patch: BuilderPropertyRecord) => void;
    },
) {
    const { functions_variables, width, onPatch } = props;

    return (
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-2 sm:gap-x-3 sm:gap-y-2">
            <LabeledTextRow
                label="Variables"
                description="Ex: a,b,c,d,e,f"
                value={functions_variables}
                rows={1}
                onValueChange={v => onPatch({ functions_variables: v })}
            />
            <LabeledSelectRow
                label="Correctness methods"
                value="Set"
                options={['Set']}
                onValueChange={() => onPatch({ correctness_methods: 'exact match' })}
            />
            <WidthField
                width={width}
                onPatch={onPatch}
            />
        </div>
    );
}

export function FunctionsToolSettings({ builderProps, onPatch }: ShortAnswerToolSettingsProps) {
    return (
        <FunctionsToolSettingsInner
            {...selectFunctionsToolProps(builderProps)}
            onPatch={onPatch}
        />
    );
}
